// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","LiveBadge":"_3DH70p","isStandalone":"_2v6n1Q","fadeInFrames":"_3puEnU"};